/* Nr. 17 (M24): Konfigurator uebernimmt die Farbe oder Groesse von der Produktseite.
   Eingebunden ueber snippets/lc-konfigurator-zugabe.liquid (Texte window.lcKonfiguratorTexte),
   Haken: sections/byop.liquid (Zeile "LC Nr. 17" nach palette-designer-bundle.js).
   Zugang zum Konfigurator: window.lcPaletteDesigner, gesetzt von der Zeile "LC Nr. 17" in
   assets/palette-designer-bundle.js direkt nach var nbApp = new PaletteDesigner().
   Rueckweg: beide Hakenzeilen entfernen; diese Datei kann liegen bleiben (ohne Zugang tut sie nichts).

   Ablauf:
   1. Parameter lc_farbe (SKU), lc_basis (SKU), lc_ersetzt (BundleId) lesen; keiner da: Ende.
   2. Die drei Parameter sofort aus der Adresse nehmen (pd bleibt). Neuladen und Zurueck legen
      dadurch nichts doppelt.
   3. Ohne window.lcPaletteDesigner (Bundle-Fehler, Haken zurueckgenommen): Ende ohne Meldung.
   4. lc_ersetzt: Ersetzen-Kontext nbEditBundle setzen (fuer einen neuen Tab), Knopf auf
      "Palette aktualisieren" wie das Inline-Skript in sections/byop.liquid.
   5. Warten, bis der Konfigurator bereit ist (Klasse nb-bereit, kein offenes Erststart-Fenster).
   6. lc_basis: Groesse ueber den Setter selectedPalette (Verlust-Rueckfrage kommt von dort).
   7. lc_farbe: addPan wie ein Tipp im Katalog (erster freier Platz, sonst Dialog groessere
      Palette); schon drin, nicht verfuegbar und voll bekommen eine eigene Meldung.
   8. Messereignis lc_palette_zeile_uebernommen nach Konvention 4.5.
   Jeder Schritt in try/catch: ein Fehler hier stoert den Konfigurator nie. */
(function () {
  'use strict';

  var NR = '17';

  /* Gemeinsamer Messhelfer, gleiche kleine Kopie in jeder lc-Datei (Konvention 4.5). */
  window.lcMessen = window.lcMessen || function (name, daten) {
    try {
      if (typeof window.hj === 'function') { window.hj('event', name); }
    } catch (e) { /* Hotjar darf das Messen nie blockieren */ }
    try {
      if (!Array.isArray(window.dataLayer)) { window.dataLayer = []; }
      window.dataLayer.push(Object.assign({ event: name, lc_nr: NR }, daten || {}));
    } catch (e) { /* dataLayer darf das Messen nie blockieren */ }
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, Object.assign({ lc_nr: NR }, daten || {}));
      }
    } catch (e) { /* Shopify Analytics darf das Messen nie blockieren */ }
  };

  function messen(name, daten) {
    try {
      window.lcMessen(name, Object.assign({ lc_nr: NR }, daten || {}));
    } catch (e) { /* Messen darf nie stoeren */ }
  }

  var qs;
  try { qs = new URLSearchParams(window.location.search); } catch (e) { return; }
  var rohFarbe = qs.get('lc_farbe');
  var rohBasis = qs.get('lc_basis');
  var rohErsetzt = qs.get('lc_ersetzt');
  if (rohFarbe === null && rohBasis === null && rohErsetzt === null) { return; }

  var farbe = /^\d{1,10}$/.test(rohFarbe || '') ? parseInt(rohFarbe, 10) : 0;
  var basis = /^\d{1,10}$/.test(rohBasis || '') ? parseInt(rohBasis, 10) : 0;
  var ersetzt = /^palette-[a-z0-9]+$/.test(rohErsetzt || '') ? rohErsetzt : '';

  /* 2. Parameter aus der Adresse nehmen */
  try {
    qs.delete('lc_farbe');
    qs.delete('lc_basis');
    qs.delete('lc_ersetzt');
    var rest = qs.toString();
    window.history.replaceState(window.history.state, '', window.location.pathname + (rest ? '?' + rest : '') + window.location.hash);
  } catch (e) { /* Adresse bleibt, der Konfigurator schreibt sie nach der ersten Aenderung ohnehin um */ }

  /* 3. Zugang */
  var zugang = window.lcPaletteDesigner;
  if (!zugang || !zugang.app) { return; }
  var app = zugang.app;
  var T = window.lcKonfiguratorTexte || {};
  var weg = ersetzt ? 'korb' : 'angefangen';
  var art = basis ? 'basis' : 'farbe';

  function meldung(titel, text) {
    try { zugang.meldung(titel || '', text || ''); } catch (e) { /* Anzeige-Detail */ }
  }
  function mitName(vorlage, produkt) {
    var n = '';
    try { n = produkt && produkt.name ? String(produkt.name) : ''; } catch (e) { n = ''; }
    return String(vorlage || '').replace('{name}', n);
  }
  function ergebnis(wert) {
    messen('lc_palette_zeile_uebernommen', { art: art, weg: weg, ergebnis: wert });
  }

  /* 4. Ersetzen-Kontext fuer den Warenkorb-Weg */
  if (ersetzt) {
    try {
      var roh = window.sessionStorage.getItem('nbEditBundle');
      var vorhanden = roh ? JSON.parse(roh) : null;
      if (!vorhanden || vorhanden.id !== ersetzt || (Date.now() - (vorhanden.ts || 0)) >= 1800000) {
        window.sessionStorage.setItem('nbEditBundle', JSON.stringify({ id: ersetzt, ts: Date.now() }));
      }
      var btn = document.querySelector('.price-and-cart button.add-to-cart');
      var span = btn && btn.querySelector('span');
      var label = btn && btn.getAttribute('data-nb-label-update');
      if (span && label) { span.textContent = label; }
    } catch (e) { /* ohne Kontext legt der Konfigurator die Palette neu dazu (heutiges Verhalten) */ }
  }

  if (!farbe && !basis) { return; }

  /* 5. Warten, bis der Konfigurator bereit ist */
  function warteBereit(weiter) {
    var start = Date.now();
    (function pruefe() {
      try {
        var w = document.getElementById('palette-designer-nh');
        var intro = document.querySelector('.page-palette-designer .nb-intro');
        var introOffen = !!(intro && !intro.hidden);
        var bereit = !!(w && w.classList.contains('nb-bereit'));
        if (bereit && !introOffen) { weiter(); return; }
        /* 10 s bis bereit; ein offenes Erststart-Fenster darf laenger stehen (bis 60 s) */
        var grenze = bereit && introOffen ? 60000 : 10000;
        if (Date.now() - start > grenze) { return; }
      } catch (e) { return; }
      window.setTimeout(pruefe, 100);
    })();
  }

  /* 6. Groesse uebernehmen */
  function basisUebernehmen() {
    var p = app.productsModel.lookup(basis);
    if (!p || p.type !== 'empty_palette' || p.isSoldOut === true) {
      meldung(T.nichtVerfuegbarTitel, T.nichtVerfuegbarBasis);
      ergebnis('nicht_verfuegbar');
      return;
    }
    if (app.productsViewModel.selectedPalette !== p) {
      app.productsViewModel._nbGroesseQuelle = 'produktseite';
      app.productsViewModel.selectedPalette = p;
    }
    ergebnis('groesse');
  }

  /* 7. Farbe legen */
  function farbeUebernehmen() {
    var pan = app.productsModel.lookup(farbe);
    if (!pan || pan.type === 'empty_palette' || pan.isSoldOut === true) {
      meldung(T.nichtVerfuegbarTitel, T.nichtVerfuegbarFarbe);
      ergebnis('nicht_verfuegbar');
      return;
    }
    var pm = app.paletteModel;
    var drin = pm.pans.some(function (pp) { return pp && pp.pan && pp.pan.id === pan.id; });
    if (drin) {
      meldung(T.schonDrinTitel, mitName(T.schonDrinText, pan));
      ergebnis('schon_drin');
      return;
    }
    var vorher = pm.pans.length;
    var passt = true;
    try {
      var pal = pm.palette;
      passt = pan.width === 26 && pan.height === 26
        ? pm._canHoldEyeshadows(pal)
        : pan.width === pal.slotWidth && pan.height === pal.slotHeight;
    } catch (e) { passt = true; }
    Promise.resolve(app.productsViewModel.addPan(pan)).then(function () {
      if (app.paletteModel.pans.length > vorher) { ergebnis('gelegt'); return; }
      var groesser = null;
      try { groesser = app.paletteModel._getNextLargerPalette(); } catch (e) { groesser = null; }
      if (passt && !groesser) {
        /* Groesste Palette voll: addPan kehrt hier still zurueck, deshalb eigene Meldung */
        meldung(T.vollTitel, mitName(T.vollText, pan));
        ergebnis('voll');
        return;
      }
      ergebnis('nicht_gelegt');
    }).catch(function () { ergebnis('fehler'); });
  }

  warteBereit(function () {
    try {
      if (basis) { basisUebernehmen(); } else { farbeUebernehmen(); }
    } catch (e) {
      ergebnis('fehler');
    }
  });
})();
